export default "https://cdn-static.gokick.com/assets/90becb6b185a352a9c07d0641a2a2a86ee77cb9a/images/picture-of-you.b930d7b92f771d9006a5673f9ae1716c.svg";